import * as React from 'react';
import { cn } from '@/lib/utils';
import { Eye, EyeOff } from 'lucide-react';

export interface PasswordInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  register?: any;
  label?: string;
  errorMessage?: {
    message: string;
  };
}

const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ register, errorMessage, className, type, label = 'Password', ...props }, ref) => {
    const [showPassword, setShowPassword] = React.useState<boolean>();
    return (
      <div className='w-full'>
        <div className='flex justify-between mb-1'>
          <label htmlFor='password' className={`text-sm text-brand-primary-text ml-1 font-medium`}>
            {label}
          </label>
        </div>
        <div className='relative w-full'>
          <input
            tabIndex='-1'
            type={showPassword ? 'text' : 'password'}
            className={cn(
              ' border border-slate-200  px-3 py-2 ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-slate-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:border-slate-800 dark:bg-slate-950 dark:ring-offset-slate-950 dark:placeholder:text-slate-400 dark:focus-visible:ring-slate-300 flex h-12 w-full items-center justify-center rounded-md !bg-brand-secondary p-3 outline-none text-sm border-none',
              className
            )}
            ref={ref}
            {...props}
            {...register}
          />
          <div className='absolute right-4 top-3 cursor-pointer'>
            {!showPassword ? (
              <Eye className='text-slate-500' onClick={() => setShowPassword(true)} />
            ) : (
              <EyeOff className='text-slate-500' onClick={() => setShowPassword(false)} />
            )}
          </div>
        </div>{' '}
        {errorMessage?.message && (
          <p className='text-red-400 text-[11px] text-left'>
            {errorMessage.message.toLowerCase().includes('invalid')
              ? 'Field is required'
              : errorMessage.message}
          </p>
        )}
      </div>
    );
  }
);
PasswordInput.displayName = 'PasswordInput';

export { PasswordInput };
